import { Injectable, Inject /*Inject api config*/ } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable, BehaviorSubject } from 'rxjs/Rx';
import { APP_CONFIG } from '../app.config';
import { apiUrl } from '../app.config';
import { IAppConfig } from '../iapp.config';
import { OpaqueToken } from '@angular/core';
import { apiUrlcommon } from '../app.config';
import { Router } from '@angular/router';
import { DataService } from './data.service';

@Injectable()
export class NewCarService {
  static headers = new Headers({ 'Content-Type': 'application/json' });
  getNewCarData = new BehaviorSubject<any>('');

  constructor(
    private http: Http,
    @Inject(APP_CONFIG) private config: IAppConfig,
    private router: Router,
    private _data: DataService
  ) { }
  getConditionsPrice() {
    const headers = new Headers();
    headers.set('auth', this._data.token);
    return this.http
      .get(this.config.apiEndpoint + '/newcar/search/conditions/price', {
        headers: headers
      })
      .map(data => data.json())
      .catch(this.handleError.bind(this));
  }

  getLoan(
    calcNo1Set: string,
    priceZk: string,
    shutokuzeiPayment: number,
    jidoushazeiPayment: number,
    juuryouzeiPayment: number,
    jibaisekiPayment: number,
    shashuKbn: number
  ) {
    let shutokuzeiPaymentString: string = '';
    let jidoushazeiPaymentString: string = '';
    let juuryouzeiPaymentString: string  = '';
    let jibaisekiPaymentString: string = '';
    let shashuKbnString: string = '';

    if (shutokuzeiPayment != null) {
      shutokuzeiPaymentString =
        ',shutokuzeiPayment%3D' + shutokuzeiPayment;
    }

    if (jidoushazeiPayment != null) {
      jidoushazeiPaymentString =
        ',jidoushazeiPayment%3D' + jidoushazeiPayment;
    }

    if (juuryouzeiPayment != null) {
      juuryouzeiPaymentString =
        ',juuryouzeiPayment%3D' + juuryouzeiPayment;
    }

    if (jibaisekiPayment != null) {
      jibaisekiPaymentString = ',jibaisekiPayment%3D' + jibaisekiPayment;
    }

    if (shashuKbn != null) {
      shashuKbnString = ',shashuKbn%3D' + shashuKbn;
    }

    const headers = new Headers();
    headers.set('auth', this._data.token);
    return this.http
      .get(
        apiUrl +
        '/newcar/loanCalculation?q=calcNo1Set=' +
        calcNo1Set +
        ',priceZk=' +
        priceZk +
        shutokuzeiPaymentString +
        jidoushazeiPaymentString +
        juuryouzeiPaymentString +
        jibaisekiPaymentString +
        shashuKbnString,
        { headers: headers }
      )
      .map(data => data.json())
      .catch(this.handleError.bind(this));
  }

  getConditionList(
    makerCd: string,
    modelCd: string,
    kaiseiYm: string,
    prefCd: string,
    isHondaStyle: string
  ) {
    const headers = new Headers();
    headers.set('auth', this._data.token);
    console.log('params: prefCd', prefCd);
    // console.log(this.config.apiEndpoint + "/newcar/grades/conditionList?q=makerCd="
    // + makerCd + ",modelCd=" + modelCd + ",kaiseiYm=" + kaiseiYm + ",prefCd=1" + ",isHondaStyle=" + isHondaStyle);
    return this.http
      .get(
        this.config.apiEndpoint +
        '/newcar/grades/conditionList?q=makerCd=' +
        makerCd +
        ',modelCd=' +
        modelCd +
        ',kaiseiYm=' +
        kaiseiYm +
        `,prefCd=${prefCd}` +
        ',isHondaStyle=' +
        isHondaStyle,
        { headers: headers }
      )
      .map(data => data.json())
      .catch(this.handleError.bind(this));
  }

  getGreadList(
    prefCd: string,
    isHondaStyle: string,
    makerCd: string,
    modelCd: string,
    kaiseiYm: string,
    displacement: Array<string>,
    drive: Array<string>,
    fuelKbn: Array<string>,
    gaisouColor: Array<string>,
    teiin: Array<string>,
    transmission: Array<string>,
    engine: Array<String>,
    makerOption: Array<string>,
    priceFrom: string,
    priceTo: string,
    nenpiFrom: string,
    nenpiTo: string,
    page: number,
    size: number,
    sort: string
  ) {
    let displacementString = '';
    let driveString = '';
    let fuelKbnString = '';
    let gaisouColorString = '';
    let teiinString = '';
    let transmissionString = '';
    let engineString = '';
    let makerOptionString = '';
    let nenpiFromString: string = nenpiFrom;
    let nenpiToString: string = nenpiTo;
    let index = 1;

    for (const item of displacement) {
      if (index == displacement.length) {
        displacementString += item;
      } else {
        displacementString += item + ',';
      }
      index++;
    }
    index = 1;
    for (const item of drive) {
      if (index == drive.length) {
        driveString += item;
      } else {
        driveString += item + ',';
      }
      index++;
    }
    index = 1;
    for (const item of fuelKbn) {
      if (index == fuelKbn.length) {
        fuelKbnString += item;
      } else {
        fuelKbnString += item + ',';
      }
      index++;
    }
    index = 1;
    for (const item of gaisouColor) {
      if (index == gaisouColor.length) {
        gaisouColorString += item;
      } else {
        gaisouColorString += item + ',';
      }
      index++;
    }
    index = 1;
    for (const item of teiin) {
      if (index == teiin.length) {
        teiinString += item;
      } else {
        teiinString += item + ',';
      }
      index++;
    }
    index = 1;
    for (const item of transmission) {
      if (index == transmission.length) {
        transmissionString += item;
      } else {
        transmissionString += item + ',';
      }
      index++;
    }
    index = 1;
    for (const item of engine) {
      if (index == engine.length) {
        engineString += item;
      } else {
        engineString += item + ',';
      }
      index++;
    }
    index = 1;
    for (const item of makerOption) {
      if (index == makerOption.length) {
        makerOptionString += item;
      } else {
        makerOptionString += item + ',';
      }
      index++;
    }
    index = 1;
    if (transmissionString == '') {
      transmissionString = '';
    } else {
      transmissionString = ',transmission%3D' + transmissionString;
    }
    if (transmissionString.substring(0, 1) == ' ')
      transmissionString = transmissionString.substring(
        1,
        transmissionString.length - 1
      );
    transmissionString = transmissionString.replace(' ', '');
    if (teiinString == '') {
      teiinString = '';
    } else {
      teiinString = ',teiin%3D' + teiinString;
    }
    teiinString = teiinString.replace(' ', '');
    if (gaisouColorString == '') {
      gaisouColorString = '';
    } else {
      gaisouColorString = ',gaisouColor%3D' + gaisouColorString;
    }
    gaisouColorString = gaisouColorString.replace(' ', '');
    if (fuelKbnString == '') {
      fuelKbnString = '';
    } else {
      fuelKbnString = ',fuelKbnValue%3D' + fuelKbnString;
    }
    fuelKbnString = fuelKbnString.replace(' ', '');
    if (driveString == '') {
      driveString = '';
    } else {
      driveString = ',driveValue%3D' + driveString;
    }
    driveString = driveString.replace(' ', '');
    if (displacementString == '') {
      displacementString = '';
    } else {
      displacementString = ',displacement%3D' + displacementString;
    }
    displacementString = displacementString.replace(' ', '');

    if (priceFrom == '') {
      priceFrom = '';
    } else {
      priceFrom = ',priceFrom%3D' + priceFrom;
    }
    priceFrom = priceFrom.replace(' ', '');
    if (priceTo == '') {
      priceTo = '';
    } else {
      priceTo = ',priceTo%3D' + priceTo;
    }
    priceTo = priceTo.replace(' ', '');

    if (engineString == '') {
      engineString = '';
    } else {
      engineString = ',engine%3D' + encodeURIComponent(engineString);
    }
    engineString = engineString.replace(' ', '');

    if (makerOptionString == '') {
      makerOptionString = '';
    } else {
      makerOptionString = ',makerOption%3D' + makerOptionString;
    }
    makerOptionString = makerOptionString.replace(' ', '');

    if (makerOptionString == '') {
      makerOptionString = '';
    } else {
      makerOptionString = ',makerOption%3D' + makerOptionString;
    }
    makerOptionString = makerOptionString.replace(' ', '');

    if (!nenpiFromString) {
      nenpiFromString = '';
    } else {
      nenpiFromString = ',nenpiFrom%3D' + nenpiFromString;
    }
    nenpiFromString = nenpiFromString.replace(' ', '');

    if (!nenpiToString) {
      nenpiToString = '';
    } else {
      nenpiToString = ',nenpiTo%3D' + nenpiToString;
    }
    nenpiToString = nenpiToString.replace(' ', '');

    if (sort) {
      sort = '&sort=' + sort;
    } else {
      sort = '&sort=makerCd';
    }
    const headers = new Headers();
    headers.set('auth', this._data.token);
    //   console.log(this.config.apiEndpoint + "/newcar/grades/search1?q=prefCd=" + prefCd + ",isHondaStyle="
    // + isHondaStyle + ",makerCd=" + makerCd + ",modelCd=" + modelCd + ",kaiseiYm=" + kaiseiYm + displacementString
    // + driveString + fuelKbnString + gaisouColorString + teiinString + transmissionString + makerOptionString + engineString
    // + nenpiFromString + nenpiToString + priceFrom + priceTo + "&page=" + page + "&size=" + size + sort);
    return this.http
      .get(
        this.config.apiEndpoint +
        '/newcar/grades/search1?q=prefCd=' +
        prefCd +
        ',isHondaStyle=' +
        isHondaStyle +
        ',makerCd=' +
        makerCd +
        ',modelCd=' +
        modelCd +
        ',kaiseiYm=' +
        kaiseiYm +
        displacementString +
        driveString +
        fuelKbnString +
        gaisouColorString +
        teiinString +
        transmissionString +
        makerOptionString +
        engineString +
        nenpiFromString +
        nenpiToString +
        priceFrom +
        priceTo +
        '&page=' +
        page +
        '&size=' +
        size +
        sort,
        { headers: headers }
      )
      .map(data => data.json())
      .catch(this.handleError.bind(this));
  }

  getNewCarDetailInfoToStorage(
    prefCd: string,
    makerCd: string,
    modelCd: string,
    kaiseiYm: string,
    gradeCd: string
  ) {
    const headers = new Headers();
    headers.set('auth', this._data.token);
    return this.http
      .get(
        this.config.apiEndpoint +
        '/newcar/grades/detail1?q=prefCd=' +
        prefCd +
        ',makerCd=' +
        makerCd +
        ',modelCd=' +
        modelCd +
        ',kaiseiYm=' +
        kaiseiYm +
        ',gradeCd=' +
        gradeCd,
        { headers: headers }
      )
      .map(data => data.json())
      .catch(this.handleError.bind(this));
  }

  getNewCarDetailInfo(
    prefCd: string,
    makerCd: string,
    modelCd: string,
    kaiseiYm: string,
    gradeCd: string
  ) {
    const headers = new Headers();
    headers.set('auth', this._data.token);
    return this.http
      .get(
        apiUrl +
        '/newcar/detail?q=prefCd=' +
        prefCd +
        ',makerCd=' +
        makerCd +
        ',modelCd=' +
        modelCd +
        ',kaiseiYm=' +
        kaiseiYm +
        ',gradeCd=' +
        gradeCd,
        { headers: headers }
      )
      .map(data => data.json())
      .catch(this.handleError.bind(this));
  }

  getNewCarList(
    prefCd: string,
    makerCd: Array<any>,
    modelCd: Array<any>,
    bodyType: Array<any>,
    priceFrom: string,
    priceTo: string,
    freeWord: string,
    kanaList: Array<string>,
    page: number,
    size: number
  ) {
    let maker_cd = '';
    let model_cd = '';
    let body_type = '';
    let kana_cd = '';
    let selectMakerPattern1_string = '';
    let index = 1;
    for (const item of makerCd) {
      if (index == makerCd.length) {
        maker_cd += item;
      } else {
        maker_cd += item + ',';
      }
      index++;
      if (item == '09999') {
        selectMakerPattern1_string = '1';
      }
    }
    index = 1;
    for (const item of modelCd) {
      if (index == modelCd.length) {
        model_cd += item;
      } else {
        model_cd += item + ',';
      }
      index++;
    }
    index = 1;
    for (const item of bodyType) {
      if (index == bodyType.length) {
        body_type += item;
      } else {
        body_type += item + ',';
      }
      index++;
    }
    index = 1;
    for (const item of kanaList) {
      if (index == kanaList.length) {
        kana_cd += item;
      } else {
        kana_cd += item + ',';
      }
      index++;
    }
    if (maker_cd == '') {
      maker_cd = '';
    } else {
      maker_cd = ',makerCd%3D' + maker_cd;
    }
    if (model_cd == '') {
      model_cd = '';
    } else {
      model_cd = ',modelCd%3D' + model_cd;
    }
    if (body_type == '') {
      body_type = '';
    } else {
      body_type = ',bodyType%3D' + body_type;
    }

    if (priceTo == '') {
      priceTo = '';
    } else {
      priceTo = ',priceTo%3D' + priceTo;
      priceTo = priceTo.replace(' ', '');
    }

    if (priceFrom == '') {
      priceFrom = '';
    } else {
      priceFrom = ',priceFrom%3D' + priceFrom;
      priceFrom = priceFrom.replace(' ', '');
    }
    if (freeWord == '') {
      freeWord = '';
    } else {
      freeWord = ',freeWord%3D' + encodeURIComponent(freeWord);
    }

    if (kana_cd == '') {
      kana_cd = '';
    } else {
      kana_cd = ',kanaCd%3D' + kana_cd;
    }

    if (selectMakerPattern1_string == '') {
      selectMakerPattern1_string = '';
    } else {
      selectMakerPattern1_string =
        ',selectMakerPattern1%3D' + selectMakerPattern1_string;
    }
    // console.log(this.config.apiEndpoint + "/newcar/models/search1?q=prefCd%3D"
    // + prefCd + maker_cd + model_cd + selectMakerPattern1_string + body_type + priceTo
    // + priceFrom + freeWord + kana_cd + "&page=" + page + "&size=" + size + "&sort=makerCd,modelNm");
    const headers = new Headers();
    headers.set('auth', this._data.token);

    return this.http
      .get(
        this.config.apiEndpoint +
        '/newcar/models/search1?q=prefCd%3D' +
        prefCd +
        maker_cd +
        model_cd +
        selectMakerPattern1_string +
        body_type +
        priceTo +
        priceFrom +
        freeWord +
        kana_cd +
        '&page=' +
        page +
        '&size=' +
        size +
        '&sort=makerCd,modelNm',
        { headers: headers }
      )
      .map(data => data.json())
      .catch(this.handleError.bind(this));
  }

  // setNewCarDataForPlan(data){
  //     this.getNewCarData.next(data);
  // }

  getColorData(
    makerCd: string,
    modelCd: string,
    kaiseiYm: string,
    gradeCd: string
  ) {
    const headers = new Headers();
    headers.set('auth', this._data.token);
    return this.http
      .get(
        `${apiUrlcommon}/newcar/grades/colors/search1?q=makerCd%3D${makerCd},modelCd%3D${modelCd},kaiseiYm%3D${kaiseiYm},gradeCd%3D${gradeCd}`,
        { headers: headers }
      )
      .map(data => data.json())
      .catch(this.handleError.bind(this));
  }

  getEnvironment() {
    const headers = new Headers();
    headers.set('auth', this._data.token);
    return this.http
      .get(apiUrl + '/user/setting/environment', { headers: headers })
      .map(data => data.json())
      .catch(this.handleError.bind(this));
  }

  getPdfNo1Set(
    prefCd: string,
    makerCd: string,
    modelCd: string,
    kaiseiYm: string,
    gradeCd: string
  ) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/pdf');
    headers.set('auth', this._data.token);
    return this.http
      .get(
        apiUrl +
        '/newcar/detail/pdfNo1Set?q=prefCd=' +
        prefCd +
        ',makerCd=' +
        makerCd +
        ',modelCd=' +
        modelCd +
        ',kaiseiYm=' +
        kaiseiYm +
        ',gradeCd=' +
        gradeCd,
        { headers: headers, responseType: ResponseContentType.Blob }
      )
      .map(response => response.blob())
      .catch(this.handleError.bind(this));
  }
  getPdfHeartPrice(
    prefCd: string,
    makerCd: string,
    modelCd: string,
    kaiseiYm: string,
    gradeCd: string
  ) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/pdf');
    headers.set('auth', this._data.token);
    return this.http
      .get(
        apiUrl +
        '/newcar/detail/pdfHeartPrice?q=prefCd=' +
        prefCd +
        ',makerCd=' +
        makerCd +
        ',modelCd=' +
        modelCd +
        ',kaiseiYm=' +
        kaiseiYm +
        ',gradeCd=' +
        gradeCd,
        { headers: headers, responseType: ResponseContentType.Blob }
      )
      .map(response => response.blob())
      .catch(this.handleError.bind(this));
  }
  getPdfGenkin2kai(
    prefCd: string,
    makerCd: string,
    modelCd: string,
    kaiseiYm: string,
    gradeCd: string
  ) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/pdf');
    headers.set('auth', this._data.token);
    return this.http
      .get(
        apiUrl +
        '/newcar/detail/pdfGenkin2kai?q=prefCd=' +
        prefCd +
        ',makerCd=' +
        makerCd +
        ',modelCd=' +
        modelCd +
        ',kaiseiYm=' +
        kaiseiYm +
        ',gradeCd=' +
        gradeCd,
        { headers: headers, responseType: ResponseContentType.Blob }
      )
      .map(response => response.blob())
      .catch(this.handleError.bind(this));
  }
  getPdfNewcarDetail(
    prefCd: string,
    makerCd: string,
    modelCd: string,
    kaiseiYm: string,
    gradeCd: string
  ) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/pdf');
    headers.set('auth', this._data.token);
    return this.http
      .get(
        apiUrl +
        '/newcar/detail/pdf?q=prefCd=' +
        prefCd +
        ',makerCd=' +
        makerCd +
        ',modelCd=' +
        modelCd +
        ',kaiseiYm=' +
        kaiseiYm +
        ',gradeCd=' +
        gradeCd,
        { headers: headers, responseType: ResponseContentType.Blob }
      )
      .map(response => response.blob())
      .catch(this.handleError.bind(this));
  }
  getComparisonBase(
    prefCd: string,
    addAMonthJibaiseki: string,
    optionFlg: string,
    gradeInfo: string[][]
  ) {
    let gradeInfoString = '';
    gradeInfo.forEach((grade, i) => {
      gradeInfoString += `,gradeCar${(i + 1)}%3D[${grade.join()}]`;
    });
    if (gradeInfo.length < 3) {
      for (let i = gradeInfo.length + 1; i < 4; i++) {
        gradeInfoString += `,gradeCar${i}%3D[]`;
      }
    }
    const headers = new Headers();
    headers.set('auth', this._data.token);
    return this.http
      .get(
        this.config.apiEndpoint +
        '/newcar/grades/comparisonBase?q=prefCd%3D' +
        prefCd +
        ',addAMonthJibaiseki%3D' +
        addAMonthJibaiseki +
        ',optionFlg=' +
        optionFlg +
        gradeInfoString,
        { headers: headers }
      )
      .map(data => data.json())
      .catch(this.handleError.bind(this));
  }
  getModelInfo(
    prefCd: string,
    makerCd: string,
    modelCd: string,
    kaiseiYm: string
  ) {
    const headers = new Headers();
    headers.set('auth', this._data.token);
    return this.http
      .get(
        this.config.apiEndpoint +
        '/newcar/models/info?q=prefCd=' +
        prefCd +
        ',makerCd=' +
        makerCd +
        ',modelCd=' +
        modelCd +
        ',kaiseiYm=' +
        kaiseiYm,
        { headers: headers }
      )
      .map(data => data.json())
      .catch(this.handleError.bind(this));
  }
  getUserInfo() {
    const headers = new Headers();
    headers.set('auth', this._data.token);
    return this.http
      .get(apiUrl + '/user/logininfo/', { headers: headers })
      .map(data => data.json())
      .catch(this.handleError.bind(this));
  }

  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    if (error.status === 401) {
      this.deleteToken();
    } else {
      return Observable.throw(errMsg);
    }
  }

  deleteToken() {
    const headerParams = NewCarService.headers;
    headerParams.set('auth', this._data.token);
    if (this._data.token !== null) {
      this.clearDataAndNavigateToLogin();
      return this.http
        .delete(`${apiUrl}/auth/token`, { headers: NewCarService.headers })
        .subscribe(() => { });
    }
  }

  clearDataAndNavigateToLogin() {
    this._data.clearData();
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/new-car.service.ts